export const PENDING_REQUESTS_KEY = ["pendingRequests"] as const;

export const PAYMENT_KEYS = [
  "creditNoteRequest",
  "recallChequeRequest",
  "creditCardRequest",
  "receiptApprovalRequest",
  "deferredRequest",
  "recallReceiptRequest",
];

export const RECEIPT_KEYS = ["recallChequeRequest", "receiptApprovalRequest", "recallReceiptRequest"];
